<template>
  <scroll-bar>
    <el-menu unique-opened mode="vertical" :default-active="$route.path" :collapse="isCollapse" background-color="#304156" text-color="#bfcbd9" active-text-color="#409EFF">
      <sidebar-item :routes="menuList"></sidebar-item>
    </el-menu>
  </scroll-bar>
</template>

<script>
import { mapGetters } from 'vuex'
import SidebarItem from './SidebarItem'
import ScrollBar from '@/components/ScrollBar/index'
import { deepClone } from "@/utils/index";

export default {
  components: { SidebarItem, ScrollBar },
  computed: {
    ...mapGetters([
      'sidebar',
      'permission_routers'
    ]),
    menuList() {
       return this.filterMenu(this.$store.getters.permission_routers)
    },
    routes() {
      return this.$router.options.routes
    },
    isCollapse() {
      return !this.sidebar.opened
    }
  },
  methods: {
      filterMenu(list) {
          return deepClone(list).filter(item => {
              if(item.children && item.children.length !==0) {
                  item.children = this.filterMenu(item.children)
              }
              return !item.hideNav
          })
      }
  }
}
</script>
